import { LinearScale, LogarithmicScale } from 'chart.js';
import { merge, drawPoint } from 'chart.js/helpers';
import { baseDefaults, LegendScale, LogarithmicLegendScale } from './LegendScale';
const scaleDefaults = {
    missing: 1,
    mode: 'area',
    range: [2, 20],
    legend: {
        align: 'bottom',
        length: 90,
        width: 70,
        indicatorWidth: 42,
    },
};
export class SizeScale extends LegendScale {
    constructor() {
        super(...arguments);
        this._model = null;
    }
    getSizeForValue(value) {
        const v = this._getNormalizedValue(value);
        if (v == null || Number.isNaN(v)) {
            return this.options.missing;
        }
        return this.getSizeImpl(v);
    }
    getSizeImpl(normalized) {
        const [r0, r1] = this.options.range;
        if (this.options.mode === 'area') {
            const a1 = r1 * r1 * Math.PI;
            const a0 = r0 * r0 * Math.PI;
            const range = a1 - a0;
            const a = normalized * range + a0;
            return Math.sqrt(a / Math.PI);
        }
        const range = r1 - r0;
        return normalized * range + r0;
    }
    _drawIndicator() {
        const { ctx } = this;
        const shift = this.options.legend.indicatorWidth / 2;
        const isHor = this.isHorizontal();
        const values = this.ticks;
        const labelItems = this.getLabelItems();
        const positions = labelItems
            ? labelItems.map((el) => ({ [isHor ? 'x' : 'y']: el.options.translation[isHor ? 0 : 1] }))
            : values.map((_, i) => ({ [isHor ? 'x' : 'y']: this.getPixelForTick(i) }));
        (this._gridLineItems || []).forEach((item) => {
            ctx.save();
            ctx.strokeStyle = item.color;
            ctx.lineWidth = item.width;
            if (ctx.setLineDash) {
                ctx.setLineDash(item.borderDash);
                ctx.lineDashOffset = item.borderDashOffset;
            }
            ctx.beginPath();
            if (this.options.grid.drawTicks) {
                switch (this.options.legend.align) {
                    case 'left':
                        ctx.moveTo(0, item.ty1);
                        ctx.lineTo(shift, item.ty2);
                        break;
                    case 'top':
                        ctx.moveTo(item.tx1, 0);
                        ctx.lineTo(item.tx2, shift);
                        break;
                    case 'bottom':
                        ctx.moveTo(item.tx1, shift);
                        ctx.lineTo(item.tx2, shift * 2);
                        break;
                    default:
                        ctx.moveTo(shift, item.ty1);
                        ctx.lineTo(shift * 2, item.ty2);
                        break;
                }
            }
            ctx.stroke();
            ctx.restore();
        });
        if (this._model) {
            const props = this._model;
            ctx.strokeStyle = props.borderColor;
            ctx.lineWidth = props.borderWidth || 0;
            ctx.fillStyle = props.backgroundColor;
        }
        else {
            ctx.fillStyle = 'blue';
        }
        values.forEach((v, i) => {
            const pos = positions[i];
            const radius = this.getSizeForValue(v.value);
            const x = isHor ? pos.x : shift;
            const y = isHor ? shift : pos.y;
            const renderOptions = {
                pointStyle: 'circle',
                borderWidth: 0,
                ...(this._model || {}),
                radius,
            };
            drawPoint(ctx, renderOptions, x, y);
        });
    }
}
SizeScale.id = 'size';
SizeScale.defaults = merge({}, [LinearScale.defaults, baseDefaults, scaleDefaults]);
SizeScale.descriptors = {
    _scriptable: true,
    _indexable: (name) => name !== 'range',
};
export class SizeLogarithmicScale extends LogarithmicLegendScale {
    constructor() {
        super(...arguments);
        this._model = null;
    }
    getSizeForValue(value) {
        const v = this._getNormalizedValue(value);
        if (v == null || Number.isNaN(v)) {
            return this.options.missing;
        }
        return this.getSizeImpl(v);
    }
    getSizeImpl(normalized) {
        return SizeScale.prototype.getSizeImpl.call(this, normalized);
    }
    _drawIndicator() {
        SizeScale.prototype._drawIndicator.call(this);
    }
}
SizeLogarithmicScale.id = 'sizeLogarithmic';
SizeLogarithmicScale.defaults = merge({}, [LogarithmicScale.defaults, baseDefaults, scaleDefaults]);
//# sourceMappingURL=SizeScale.js.map